import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
/*App imports*/
import { HelpersService } from '../../../services/tools/helpers.service';
import { PlazosService } from "../../../services/plazos.service";
import { CreditosService } from "../../../services/creditos.service";
import { PersonalesService } from '../../../services/creditos/personales.service';
import { ConveniosService } from '../../../services/convenios.service';



@Component({
  selector: 'personal-simulador',
  templateUrl: './personal-simulador.component.html',
  styleUrls: ['./personal-simulador.component.scss'],
})

export class PersonalSimuladorComponent implements OnInit {
  //Constants
  private tipoCredito = 5;
  //UI
  public cliente: any = {};
  public prestamo: any = {};
  public plazos: any = [];
  public plazoSelected: any = '';
  public catalogoPeriodicidad: any = {};
  public catalogoTipoCalculo: any = {};
  public errors: any = {};
  //Subscriptions
  private sub: any;
  //Edit mode
  private id: number = null;
  //Selección de convenio
  public convenioDefault = "";
  public convenioSelected: any = { id: null };
  public optConvenios = []


  constructor(
    private helperService: HelpersService,
    private location: Location,
    private plazosService: PlazosService,
    private creditosService: CreditosService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private personalesService: PersonalesService,
    private conveniosService: ConveniosService
  ) {
  }

  public ngOnInit() {
    this.setDefaultValues();
    this.getConvenios();
    this.getPlazos();
    this.sub = this.activeRoute.params.subscribe(params => {
      if (params['id']) {
        //Edit mode
        this.id = params['id'] ? +params['id'] : 0; // (+) converts string 'id' to a number
        this.getCredito(this.id);
      }
    });
  }

  public getConvenios() {
    // let filters = this.getActiveFilters();

    this.conveniosService.getAll({ tipo: "Personal" }).subscribe(
      (response) => {
        let respuesta = response.json().content;
        console.log(respuesta);
        if (respuesta.length > 1) {
          this.optConvenios = respuesta;
          this.convenioDefault = "Sin convenio";
        } else {
          this.optConvenios = respuesta;
          this.convenioDefault = "Sin convenio";
          this.prestamo.idConvenio = null;
        }
      }, error => {
      // se resuelve error 403 y 500
      this.helperService.httpGlobalError(error);

      if (error.status == 400) {
        this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
      }
    }
    );
  }

  convenioChanged(tipo) {
    console.log("Event convenio: ", tipo);

    if (tipo.id) {
      this.convenioSelected = tipo;
      // this.convenio.tipo_convenio = this.tipoSelected.nombre;
      // console.log("Tipo convenio: ",this.automotriz);
      // this.prestamos.calculo = this.convenioSelected.calculo;
      this.prestamo.periodicidad = this.convenioSelected.periodicidad;
      this.prestamo.idConvenio = this.convenioSelected.id;
    } else {
      this.setDefaultValues();
    }
  }
  private selectConvenio(idConvenio: number) {
    // 1. Buscamos el objeto exacto en el catálogo que cargaste previamente
    const convenioEncontrado = this.optConvenios.find(c => c.id == idConvenio);

    if (convenioEncontrado) {
      // 2. Asignamos el objeto. Al ser la misma referencia del array [options], 
      // Select2 lo marcará como seleccionado.
      this.convenioSelected = convenioEncontrado;
    } else {
      // Opcional: manejar si no se encuentra
      this.convenioSelected = null;
    }
  }

  private setDefaultValues() {
    this.prestamo.calculo = 2;//Default crédito simple
    this.prestamo.periodicidad = 2;//Periodicidad Mensual
    this.catalogoPeriodicidad = this.creditosService.getCatalogoPeriodicidad();
  }

  private getCredito(idCredito: number) {

    //TODO: Manejar cuando el id no retorna un crédito valido
    this.creditosService.get(idCredito).subscribe(
      (response) => {
        const result = response.json().content;
        this.prestamo = result.prestamo;
        this.cliente = result.cliente;
        this.selectConvenio(result.idConvenio);
        this.selectPlazo(result.prestamo);
      }, error => {
      // se resuelve error 403 y 500
      this.helperService.httpGlobalError(error);

      if (error.status == 400) {
        this.helperService.setBackendErrors(error.json().content, this.errors);
        this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
      }
    }
    );
  }

  public save() {
    this.errors = {};
    if (this.convenioSelected && this.convenioSelected.id) {
      this.prestamo.idConvenio = this.convenioSelected.id;
    }

    let credito = {
      idCreditos: null,
      prestamo: this.prestamo,
      cliente: null
    };

    if (typeof this.cliente.email === 'object') {
      //Cuando se selecciono un usuario con Typeahead, 
      //el modelo cliente.email tiene asociado un objeto con todos los datos del cliente
      let clienteToSave = {
        email: this.cliente.email.email,
        nombre: this.cliente.nombre,
        //Cuando es un update el modelo this.cliente tiene todos los datos del cliente
        //En el caso del create en el modelo this.cliente.email Typeahead pone el JSON completo del Cliente
        id: (this.cliente.id ? this.cliente.id : this.cliente.email.id)
      };
      credito.cliente = clienteToSave;
    } else {
      //Caso cuando el email se ingreso de forma manual
      credito.cliente = this.cliente;
    }

    //El plazo seleccionado esta en el modelo plazoSelected, se debe actualizar el valor en el modelo que se enviará al servicio
    if (this.plazoSelected) {
      //Default solo para pruebas
      credito.prestamo.plazo_periodo = this.plazoSelected.periodo;
      credito.prestamo.plazo_medida = this.plazoSelected.medida;
    }

    this.errors = this.personalesService.validate(credito);
    if (Object.entries(this.errors).length > 0) {
      return false;
    }

    if (this.id) {
      //Update credito
      //set idCreditos
      credito.idCreditos = this.id;
      this.update(credito);
    } else {
      //New credito
      this.create(credito);
    }
  }

  private create(credito: any) {
    this.personalesService.save(credito).subscribe(
      (response) => {
        const result = response.json().content;
        //Navigate to tabla de amortizacion
        this.router.navigate(['/creditos/tabla-amortizacion/', result.id]);
      }, error => {
      // se resuelve error 403 y 500
      this.helperService.httpGlobalError(error);

      if (error.status == 400) {
        this.helperService.showSaveCreditErrors(error.json().content, this.errors);
      }
    }
    );
  }


  private update(credito) {
    this.personalesService.update(credito).subscribe(
      (response) => {
        const result = response.json().content;
        //Navigate to tabla de amortizacion
        this.router.navigate(['/creditos/tabla-amortizacion/', this.id]);
      }, error => {
      // se resuelve error 403 y 500
      this.helperService.httpGlobalError(error);

      if (error.status == 400) {
        this.helperService.showSaveCreditErrors(error.json().content, this.errors);
      }
    }
    );
  }

  public goBack() {
    this.location.back();
  }

  /**
   * Helpers
   */
  private getPlazos() {
    this.plazosService.getAll(this.tipoCredito).subscribe(
      (response) => {
        this.plazos = response.json().content;
      }, error => {
      // se resuelve error 403 y 500
      this.helperService.httpGlobalError(error);

      if (error.status == 400) {
        this.helperService.setBackendErrors(error.json().content, this.errors);
        this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
      }
    }
    );
  }

  private selectPlazo(prestamo: any) {
    let selectedPlazo = null;
    this.plazos.forEach(function (element) {

      if (prestamo.plazo_periodo === element.periodo && prestamo.plazo_medida === element.medida) {
        selectedPlazo = element;
      }
    });

    if (selectedPlazo) {
      this.plazoSelected = selectedPlazo;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/creditos/personal/simulador/personal-simulador.component.ts